import {SearchItem, SearchResultDto} from "./search-table.dto.res";
import {ContactDto} from "../contact.dto";

export class SearchContactRes extends SearchResultDto {

  public override readonly items: SearchContactItem[] = [];

  constructor(init?: Partial<SearchContactRes>) {
    super(init);
    if (init?.items) {
      this.items = init.items.map((i) => new SearchContactItem(i));
    } else {
      this.items = [];
    }
  }
}

export class SearchContactItem extends ContactDto implements SearchItem {

  public override readonly id!: string;
  public readonly streetWithNo: string | undefined;
  public readonly city: string | undefined;
  public readonly zipCode: string | undefined;
  public readonly phone: string | undefined;

  constructor(init?: Partial<SearchContactItem>) {
    super(init);
    Object.assign(this, init);
  }
}
